// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OTilie Answer Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The persisted subset of a citation (interaction_citations columns) —
 * no passage_text/relevance_score/modified_at, those are not stored.
 * @export
 * @interface ConversationCitationResponse
 */
export interface ConversationCitationResponse {
    /**
     * 
     * @type {number}
     * @memberof ConversationCitationResponse
     */
    documentNumber: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationCitationResponse
     */
    documentName: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationCitationResponse
     */
    docUrl: string;
    /**
     * 
     * @type {ConversationCitationResponseSourceTypeEnum}
     * @memberof ConversationCitationResponse
     */
    sourceType: ConversationCitationResponseSourceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConversationCitationResponse
     */
    scrapingSource: string;
}


/**
 * @export
 */
export const ConversationCitationResponseSourceTypeEnum = {
    Sharepoint: 'sharepoint',
    Tqm: 'tqm',
    Webscraping: 'webscraping'
} as const;
export type ConversationCitationResponseSourceTypeEnum = typeof ConversationCitationResponseSourceTypeEnum[keyof typeof ConversationCitationResponseSourceTypeEnum];


/**
 * Check if a given object implements the ConversationCitationResponse interface.
 */
export function instanceOfConversationCitationResponse(value: object): value is ConversationCitationResponse {
    if (!('documentNumber' in value) || value['documentNumber'] === undefined) return false;
    if (!('documentName' in value) || value['documentName'] === undefined) return false;
    if (!('docUrl' in value) || value['docUrl'] === undefined) return false;
    if (!('sourceType' in value) || value['sourceType'] === undefined) return false;
    if (!('scrapingSource' in value) || value['scrapingSource'] === undefined) return false;
    return true;
}

export function ConversationCitationResponseFromJSON(json: any): ConversationCitationResponse {
    return ConversationCitationResponseFromJSONTyped(json, false);
}

export function ConversationCitationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationCitationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'documentNumber': json['document_number'],
        'documentName': json['document_name'],
        'docUrl': json['doc_url'],
        'sourceType': json['source_type'],
        'scrapingSource': json['scraping_source'],
    };
}

export function ConversationCitationResponseToJSON(json: any): ConversationCitationResponse {
    return ConversationCitationResponseToJSONTyped(json, false);
}

export function ConversationCitationResponseToJSONTyped(value?: ConversationCitationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'document_number': value['documentNumber'],
        'document_name': value['documentName'],
        'doc_url': value['docUrl'],
        'source_type': value['sourceType'],
        'scraping_source': value['scrapingSource'],
    };
}

